import { NumberSettingCard } from "../components/NumberSettingCard";
import { settingsService } from "../services/settingsService";
import type { SettingsTabProps } from "./settingsTabTypes";

export const JourneySettingsTab = ({ settings, onSettingsChange }: SettingsTabProps) => {
  const handleUpdateJourneyDailyMaxBrainPoints = async (value: number) => {
    await settingsService.updateJourneyDailyMaxBrainPoints(value);
    onSettingsChange({ journeyDailyMaxBrainPoints: value });
  };

  const handleUpdateJourneyInitialEnergy = async (value: number) => {
    await settingsService.updateJourneyInitialEnergy(value);
    onSettingsChange({ journeyInitialEnergy: value });
  };

  return (
    <>
      <NumberSettingCard
        title="Journey Daily Max Brain Points"
        description="Brain points a user can earn per day before the daily meter fills (building pathways). Applies to all users."
        value={settings.journeyDailyMaxBrainPoints}
        onSave={handleUpdateJourneyDailyMaxBrainPoints}
      />
      <NumberSettingCard
        title="Journey Energy Pool"
        description="Energy a user starts with and refills to each new day. Applies to all users on their next daily refill."
        value={settings.journeyInitialEnergy}
        onSave={handleUpdateJourneyInitialEnergy}
      />
    </>
  );
};
